import React, { FunctionComponent } from 'react';
import type { RecruitmentShowApplicationsSubProps } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowApplicationsSubProps & {
  applications: Recruitment[];
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  noimage,
  title,
  dataCategory,
  dataValue,
  applications,
  isPreview
}) => {
  if (applications.length === 0) return null

  return (
    <div className="recruitment__show__content recruitment__show__company" id="company-recruitments-section">
      <h2 className="mainTitle">
        {title}
        <a
          className="link gtm-button-view-count"
          href={`/companies/${companyId}/recruitments`}
          {...(!isPreview && {
            'data-event-name': 'button on screen',
            'data-event': 'click',
            'data-category': dataCategory,
            'data-value': dataValue.moreSelfRecruitments
          })}
        >
          もっと見る
        </a>
      </h2>

      <div className="recruitment__show__applications__slider js-recruitment-applications-sub">
        {applications.map(application => (
          <a
            key={application.id}
            href={`/recruitments/${application.id}`}
            className={`box ${!isPreview ? 'gtm-recruitment-view-count' : ''}`}
            target="_blank"
            rel="noopener noreferrer"
            {...(!isPreview && {
              'data-event-name': 'recruitments on screen',
              'data-event': 'click',
              'data-category': dataCategory,
              'data-value': dataValue.relatedSelfRecruitments,
              'data-recruitmentid': application.id,
              'data-companyid': application.companyId
            })}

          >
            {application.image.url !== null ? (
              <img src={application.image.url} alt={`${application.title}の画像`} />
            ) : (
              <img src={noimage} alt={`${application.title}の画像`} />
            )}
            <p className="title">
              <span className="occupation">{application.title}</span>
              <span className="prefecture">{application.prefecture}</span>
            </p>
            <p className="body">{application.body}</p>
          </a>
        ))}
      </div>
    </div>
  );
};
